import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription, interval } from 'rxjs';

declare var decimalInput: any;
declare function initiateMMFIB():any;


@Component({
  selector: 'app-mmfib',
  templateUrl: './mmfib.html',
  styleUrls: ['./mmfib.scss']
})

export class MMFIB implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public responseText = "";
  public mmfibresultInterval = null;

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
        this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMMFIBAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }
  
  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.responseText = "";
    this. mmfibresultInterval = null;
  }
  
  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 1028) return;

    var currentQuestion = this.dataSvc.currentQuestion();
    this.responseText = currentQuestion.Result.Selection;

    //ATTEMPT TO GET THE ANSWER EVER 1 SECOND AND SAVE TO RESULT SELECTION
    this.mmfibresultInterval = setInterval(()=>{
      this.saveResponse();
    },1000);

    var lstKeywords = currentQuestion.Question.Question.Keywords.split(",");
    var lstAnswers = this.responseText.split(",");
    var answersHTML = [];
    var answerMediaArr = [];
    var questionHTML = currentQuestion.Question.QuestionText;

    
    //GET THE ANSWER IF THERE IS ONE FOR THE CHOSEN KEYWORD
    //FILTER THE LIST OF MEDIA TO GET THE MEDIA ID FROM THE ANSWER
    //SET THE DROPZONE HTML TO BE THAT MEDIA
    for(var i = 1; i <= lstKeywords.length - 1; i++){
        if(lstKeywords[i - 1] !== ""){
          var media = lstKeywords[i - 1];
            if(lstAnswers[i -1] !== null && lstAnswers[i -1] !== undefined){
              var answer = lstAnswers[i - 1];

              var answerMedia = lstKeywords.filter(x => x.indexOf("media='" + answer + "'") > -1)[0];
              if(answerMedia !== undefined && answerMedia !== null && answerMedia !== ""){
                //SET HIDDEN FIELD TO BE THE MEDIA ID SO THAT IT SAVES THE WAY ITS NEEDED IN THE DB
                var element = "hfMMKeywordAnswer" + i;
                if(element !== null && element !== undefined){
                  (<HTMLInputElement>document.getElementById(element)).value = answer;
                }

                questionHTML = questionHTML.replace("(" + i + ")", this.getDropZoneHTML(i, answerMedia));
                answerMediaArr.push(answerMedia);                                  
              }
              else{    
                //IF IT HASNT BEEN ANSWERED OR CANT FIND THE MATCH SET THE DROPZONE TO BE EMPTY            
                questionHTML = questionHTML.replace("(" + i + ")", this.getDropZoneHTML(i, null));
              }              
            }
            else{
              //IF IT HASNT BEEN ANSWERED SET THE DROPZONE TO BE EMPTY     
              var media = lstKeywords[i - 1];
              if(media !== undefined && media !== null){
                  questionHTML = questionHTML.replace("(" + i + ")", this.getDropZoneHTML(i, null))
              }
            }
        }
        
    }

    //CHECK THE ANSWERED DROPS AND ONLY SHOW OPTIONS THAT HAVE YET TO BE SELECTED
    for(var x = 0; x < lstKeywords.length -1; x++){
      if(answerMediaArr.indexOf(lstKeywords[x]) < 0){
        var dropOptionHTML = this.GetDropOptionHTML(lstKeywords[x]);
        answersHTML.push(dropOptionHTML);
      }
    }

    document.getElementById("dQuestionText").innerHTML = questionHTML;
    document.getElementById("dDragndropOptionsArea").innerHTML = answersHTML.join(" ");

    //FIRE JS CODE IN INDEX.HTML
    initiateMMFIB();    
  }

  //SET UP THE DROPZONE HTML
  getDropZoneHTML(keywordNumber, media)
  {
      var html = "";
      html += "<span class='dropzone' dropzone-index='" + keywordNumber.toString() + "' style='display: inline-block; width: 250px;'>";
      html += "<span class='previewdrop-connector' style='display: inline-block; width: 250px;'>";

      if (media != null && media != "")
      {
          html +=  "<span class='previewdropzoneoption mmfib' style='border:none;'>" + media + "</span>";
      }

      html += "</span>";
      html += "</span>";

      return html;
  }

  //SET UP THE DROP OPTIONS HTML
  GetDropOptionHTML(media)
  {
      if (media != null)
      {
          var html = "";
          html += ("<span class='previewdropzoneoption mmfib'>");
          html += media;
          html += "</span>";
          return html;
      }
      return "";
  }

  saveResponse(){
    var currentQuestion = this.dataSvc.currentQuestion();    
    if(currentQuestion.Question.QuestionType === 1028){
    var numberofanswers = currentQuestion.Question.Question.Keywords.split(",").length - 1;
    var answerStr = "";
    for(var i = 1; i <= numberofanswers; i++){
      var element = "hfMMKeywordAnswer" + i;
      if(element !== null && element !== undefined){
        var input = (<HTMLInputElement>document.getElementById(element));
        if(input !== null && input !== undefined){
          var value = input.value;
            if(i == numberofanswers){
              answerStr += value;
            }
            else{
              answerStr += value + ",";
            }
        }
        else{
          //CLEAR INTERVAL WHEN YOU MOVE AWAY FROM THIS QUESTION AS FIELD WILL BE NULL
          clearInterval();
        }
        
      }
    }
    currentQuestion.Result.Selection = answerStr;
  }
  else{
    //CLEAR INTERVAL WHEN YOU MOVE AWAY FROM THIS QUESTION AS FIELD WILL BE NULL
    clearInterval(this.mmfibresultInterval);
  }
}
 
}
